import { DEFAULT_IMAGE_HORIZONTAL } from '../constants'
import { baseSchemaProperties } from '../base-schema-properties'
import { titleSchemaProperties, blockShadowSchemaProperties } from '../common'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Tiles',
  description: 'Block with tiles (main page menu)',
  type: 'object',
  properties: {
    ...baseSchemaProperties,
    ...titleSchemaProperties,
    ...blockShadowSchemaProperties,
    tiles: {
      type: 'array',
      title: 'A list of tiles',
      'ui:options': {
        showIndexNumber: true,
      },
      items: {
        title: 'Tiles',
        type: 'object',
        properties: {
          imageUrl: {
            title: 'Image url',
            type: 'string',
            default: DEFAULT_IMAGE_HORIZONTAL,
          },
          title: {
            title: 'Title',
            type: 'string',
            default: 'Title',
          },
          link: {
            title: 'Tile link',
            type: 'string',
          },
        },
      },
    },
  },
}
